import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef, useEffect } from 'react';
import { composeEventHandlers } from '@reach/utils';
import { Button } from '../../Button/Button.js';
import '../../Button/ButtonBase/index.js';
import '../../Button/ButtonBody/index.js';
import { useComposedRefs } from '../../hooks/useComposedRefs.js';
import { useToggleTipContext } from './ToggleTipProvider.js';
import { useToggleTipButton } from '../hooks/useToggleTipButton.js';

var ToggleTipButton = forwardRef(function ToggleTipButton(_a, ref) {
    var onKeyDown = _a.onKeyDown, onMouseDown = _a.onMouseDown, id = _a.id, _b = _a.look, look = _b === void 0 ? "link" : _b, props = __rest(_a, ["onKeyDown", "onMouseDown", "id", "look"]);
    var _c = useToggleTipContext(), buttonRef = _c.buttonRef, _d = _c.state, buttonId = _d.buttonId, isOpen = _d.isOpen;
    var _e = useToggleTipButton(), handleKeyDown = _e.handleKeyDown, handleMouseDown = _e.handleMouseDown, setButtonId = _e.setButtonId;
    var forwardedRef = useComposedRefs(buttonRef, ref);
    useEffect(function () {
        setButtonId(id);
    }, [id]);
    return (jsx(Button
    // Comments inherited from @reach:
    // When the toggleTip is displayed, the element with role `button` has
    // `aria-expanded` set to `true`. When the toggleTip is hidden, it is
    // recommended that `aria-expanded` is not present.
    // https://www.w3.org/TR/wai-aria-practices-1.2/#menubutton
    , __assign({ "aria-expanded": isOpen ? true : undefined, "aria-haspopup": true, look: look }, props, { ref: forwardedRef, id: buttonId, onKeyDown: composeEventHandlers(onKeyDown, handleKeyDown), onMouseDown: composeEventHandlers(onMouseDown, handleMouseDown), type: "button" })));
});

export { ToggleTipButton };
//# sourceMappingURL=ToggleTipButton.js.map
